<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px;height: auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Remark Master</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form v-if="
                $sessionsStorage.get('designation') == 'Admin' &&
                $sessionsStorage.get('nameUser') == 'Bhavneesh'
              ">
              <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
              <b-button variant="outline-success" class="ml-2" @click="showBulkUploadModal" size="sm">Bulk Upload</b-button>
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>{{ RemarkMaster.documentName }} Remark Details</h5>
                </b-col>
                <b-col md="3">
                  <label for="ModuleType">Module Type</label>
                  <model-list-select :isDisabled="true" :list="ModuleTypeList" v-model="RemarkMaster.ModuleType"
                    option-value="ModuleTypeVal" option-text="ModuleTypeTxt"
                    placeholder="Please Select ModuleType"></model-list-select>
                </b-col>
                <b-col md="3">
                  <label for="documentName">Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" id="documentName" name="documentName"
                    v-model="RemarkMaster.documentName" placeholder="Remark Name"></b-form-input>
                  <span class="error" v-if="!RemarkMaster.documentName">
                    {{ errorList.documentName }}
                  </span>
                </b-col>
                
                <b-col md="6" id="descriptionDiv" style="display:block;">
                  <label> Description </label>
                  <b-form-textarea :formatter="capitalizeAll" id="description" name="description"
                    v-model="RemarkMaster.description"></b-form-textarea>
                </b-col>
                <b-col md="3">
                  <label>Status :</label>
                  <md-switch :id="'approval' + RemarkMaster.isDocumentActive" name="approval" class="md-primary"
                    :value="RemarkMaster.isDocumentActive == 1 ? true : false"
                    @change="activateRemarkMaster()">
                    <h6>
                      <b-badge :variant="
                          RemarkMaster.isDocumentActive == 1 ? 'success' : 'danger'
                        ">{{
                        RemarkMaster.isDocumentActive == 1
                        ? "Active"
                        : "In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addRemarkMaster"
                      class="mt-2" id="addButtonLoader">
                      {{ RemarkMaster.remarkId ? "Update" : "Save" }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Remark" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <h5>
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="All_Remark_List_data" :fields="fields"
                  :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="remarkId" class="position-relative">
                  <template slot="remarkId" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="ModuleType" slot-scope="row55">
                    <span>{{
                      row55.item.ModuleType != "" ? row55.item.ModuleType : "--"
                      }}</span>
                  </template>
                  <template slot="documentName" slot-scope="row11">
                    <span>{{
                      row11.item.documentName != "" ? row11.item.documentName : "--"
                      }}</span>
                  </template>
                  <template slot="isDocumentActive" slot-scope="row22">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row22.item.remarkId">
                      <md-switch :id="'approval' + row22.item.remarkId" name="approval" class="md-primary"
                        :value="row22.item.isDocumentActive == 1 ? true : false"
                        @change="activateRemarkUser(row22.item)">
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row22.item.isDocumentActive == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row22.item.remarkId">
                      <h6>
                        <b-badge>{{
                          row22.item.isDocumentActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </div>
                  </template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editRemarkMaster(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    
    <b-modal id="bulkUploadModal" v-model="showBulkModal" title="Bulk Upload Remarks" size="lg" hide-footer>
       <b-form-group label="Select Excel File" label-for="file-input">
        <b-form-file
          id="file-input"
          v-model="uploadFile"
          :state="Boolean(uploadFile)"
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
          accept=".xlsx, .xls"
          @change="handleFileUpload"
        ></b-form-file>
      </b-form-group>
      
      <div v-if="uploadPreview.length > 0" class="mt-3">
        <h5>Preview ({{ uploadPreview.length }} records)</h5>
         <b-table striped hover :items="uploadPreview" :fields="['documentName', 'ModuleType', 'description']" small responsive style="max-height: 300px; overflow-y: auto;"></b-table>
          <div class="text-right mt-2">
            <b-button variant="primary" @click="submitBulkUpload" :disabled="uploadLoading">
              <b-spinner small v-if="uploadLoading"></b-spinner>
              {{ uploadLoading ? 'Uploading...' : 'Upload' }}
            </b-button>
          </div>
      </div>
      <div v-if="uploadError" class="text-danger mt-2">
        {{ uploadError }}
      </div>
       <div v-if="uploadSuccess" class="text-success mt-2">
        {{ uploadSuccess }}
      </div>
    </b-modal>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import * as XLSX from "xlsx";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import "vue-loading-overlay/dist/vue-loading.css";
import { DateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import RemarkService from "../../services/RemarkService.js";
import CustomLoader from "../common/customLoader.vue";
import { lastVisitPage } from "../../helper/collection";

export default {
  beforeMount() {
     lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
  
      this.getAllRemarkMasterList();
   
  },
  data() {
    return {
      addEditCard: false,
      isLoading: false,
      showBulkModal: false,
      uploadFile: null,
      uploadPreview: [],
      uploadLoading: false,
      uploadError: "",
      uploadSuccess: "",
      fields: [
        {
          key: "remarkId",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ModuleType",
          label: "Module Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "documentName",
          label: "Remark Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "isDocumentActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      currentPage: 1,
      perPage: 10,
      adminToggle: this.$sessionsStorage.get("designation"),
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ModuleTypeList: [
        {
          ModuleTypeVal: "Pridel Document",
          ModuleTypeTxt: "Pridel Document",
        },
        {
          ModuleTypeVal: "Sline",
          ModuleTypeTxt: "Sline",
        },
        {
          ModuleTypeVal: "Expense Port",
          ModuleTypeTxt: "Expense Port",
        },
        {
          ModuleTypeVal: "Expense",
          ModuleTypeTxt: "Expense",
        },
        {
          ModuleTypeVal: "PL Remarks",
          ModuleTypeTxt: "PL Remarks",
        },
        {
          ModuleTypeVal: "SLINE DISPUTE",
          ModuleTypeTxt: "SLINE DISPUTE",
        },
      ],
      RemarkMaster: {
        remarkId: "",
        ModuleType: "PL Remarks",
        documentName: "",
        description: "",
        isDocumentActive: 1,
      },
      RemarkMasterError: ["Please Enter Remark Name"],
      errorList: {
        documentName: "",
      },
      All_Remark_List_data: [],
      validate: true,
    };
  },
  watch: {
    currentPage: {
      handler: function () {
        this.getAllRemarkMasterList();
      },
    },
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
    MultiSelect,
  },
  methods: {
    capitalizeAll(value) {
      if (!value) return ''
      return value.toUpperCase()
    },
    activateRemarkMaster() {
       // Toggle local state for form
      if (
        this.RemarkMaster.isDocumentActive == 1 ||
        this.RemarkMaster.isDocumentActive == true
      ) {
        this.RemarkMaster.isDocumentActive = 0;
      } else {
        this.RemarkMaster.isDocumentActive = 1;
      }
    },
    activateRemarkUser(item) {
        // Toggle item status in list and call API
      this.isLoading = true;
      let newStatus = item.isDocumentActive == 1 ? 0 : 1;
      let payload = Object.assign({}, item, { isDocumentActive: newStatus });


      RemarkService.upsertRemark(payload)
        .then((response) => {
          const { data, status } = response;
          if (status == 200 && data.status) {
             item.isDocumentActive = newStatus; // Update local list
             this.alert.content = "Status Updated Successfully";
             this.$refs["addPop"].open();
          } else {
             this.alert.content = "Status Update Failed";
             this.$refs["addPop"].open();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Error updating status: ", error);
          this.isLoading = false;
        });
    },
    validateRemarkMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.RemarkMaster[x] == "" ||
          this.RemarkMaster[x] == undefined ||
          this.RemarkMaster[x] == null
        ) {
          this.errorList[x] = this.RemarkMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    addRemarkMaster() {
      this.validateRemarkMaster();
      if (this.validate == false) return false;
      this.isLoading = true;

      // Ensure remarkId is sent appropriately (integer or null, handled by service/backend)
      if(this.RemarkMaster.remarkId === "") delete this.RemarkMaster.remarkId;

      RemarkService.upsertRemark(this.RemarkMaster)
        .then((response) => {
          const { data, status } = response;
           if (status == 200 && data.status) {
              this.alert.content = data.message;
              this.getAllRemarkMasterList();
              this.addEditCardFunc();
           } else {
              this.alert.content = data.message || "Failed to save";
           }
            this.isLoading = false;
            this.$refs["addPop"].open();
        })
        .catch((error) => {
           console.log("Error saving remark: ", error);
           this.isLoading = false;
        });
    },
    clearErrVal() {
      this.RemarkMaster = {
        ModuleType: "PL Remarks",
        documentName: "",
        description: "",
        isDocumentActive: 1,
      };
      this.errorList = { documentName: "" };
    },
    getAllRemarkMasterList() {
      // alert("Fetching all remark master list...");
      this.isLoading = true;
      let payload = {
         isAll: 0, 
         pageNo: this.currentPage,
         pageSize: this.perPage,
         ModuleType: this.RemarkMaster.ModuleType
      };
      if(this.filter) {
         
      }
      
      payload.isAll = '0'; 

      RemarkService.getAllRemarkList(payload)
        .then((response) => {
          const { data, status } = response;
          if (status == 200 && data.status) {
            this.All_Remark_List_data = data.data;
            this.totalRows = data.pagination ? data.pagination.total : data.data.length;
          } else {
            this.All_Remark_List_data = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Error fetching remarks: ", error);
          this.isLoading = false;
        });
    },

    editRemarkMaster(item) {
      this.clearErrVal();
      this.addEditCard = true;
      this.RemarkMaster = Object.assign({}, item); // Clone to avoid direct mutation
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function () {
       if(this.$refs.search) { // search input might not be the right place to focus on edit, maybe rename input in form
          // Note: Ref search is on list search. Ref for Name input?
          // documentTypeMaster set focus on search ref, which is odd. I'll leave it or remove it.
       }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getAllRemarkMasterList();
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getAllRemarkMasterList();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showBulkUploadModal() {
      this.uploadFile = null;
      this.uploadPreview = [];
      this.uploadError = "";
      this.uploadSuccess = "";
      // Use ref instead of $bvModal to ensure it works, or simply set a data property if using v-model
      // Since I added v-model="showBulkModal" (wait, I need to add that first), I will do that.
      this.showBulkModal = true;
    },
    handleFileUpload(event) {
        const file = event.target.files[0];
        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const json = XLSX.utils.sheet_to_json(worksheet);
                
                // Validate and map data
                const mappedData = json.map(row => ({
                    jobNo: row['Job No'] || row['jobNo'],
                    documentName: row['Main Remarks'] || row['remarkName'] || row['Name'],
                    ModuleType: 'PL Remarks', //row['Module Type'] || row['ModuleType'],
                    description: row['Remarks'] || row['description']
                })).filter(item => item.documentName && item.ModuleType);

                // Deduplicate based on documentName (case-insensitive)
                const uniqueRemarks = new Map();
                this.uploadPreview = [];
                
                for (const item of mappedData) {
                    const normalizedName = item.documentName.trim().toLowerCase();
                    if (!uniqueRemarks.has(normalizedName)) {
                        uniqueRemarks.set(normalizedName, true);
                        this.uploadPreview.push(item);
                    }
                }

                 if (this.uploadPreview.length === 0) {
                    this.uploadError = "No valid records found. Please check columns: Remark Name, Module Type.";
                 } else {
                    this.uploadError = "";
                 }

            } catch (err) {
                console.error("Error parsing Excel:", err);
                this.uploadError = "Failed to parse Excel file.";
            }
        };
        reader.readAsArrayBuffer(file);
    },
    submitBulkUpload() {
      if(this.uploadPreview.length === 0) return;
      
      this.uploadLoading = true;
      this.uploadError = "";
      
      const payload = {
        documents: this.uploadPreview
      };

      RemarkService.bulkUploadRemark(payload)
        .then(response => {
           if(response.data.status) {
             this.uploadSuccess = response.data.message;
             this.getAllRemarkMasterList();
             setTimeout(() => {
               this.showBulkModal = false;
             }, 1500);
           } else {
             this.uploadError = response.data.message;
           }
           this.uploadLoading = false;
        })
        .catch(error => {
           this.uploadError = "Upload failed: " + (error.message || "Unknown error");
           this.uploadLoading = false;
        });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// remarkMaster.vue?a1d0e172